import React from 'react';

export default ({ style, color = 'black' }) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    xmlSpace="preserve"
  >
    <path
      fill={color}
      d="M93.5,0h-87C2.9,0,0,2.9,0,6.5v67.4c0,3.6,2.9,6.5,6.5,6.5h33.9l-9.3,9.3c-0.4,0.4-0.6,1-0.6,1.5v6.5  c0,1.2,1,2.2,2.2,2.2h34.8c1.2,0,2.2-1,2.2-2.2v-6.5c0-0.6-0.2-1.1-0.6-1.5l-9.3-9.3h33.9c3.6,0,6.5-2.9,6.5-6.5V6.5  C100,2.9,97.1,0,93.5,0z M6.5,4.3h87c1.2,0,2.2,1,2.2,2.2v58.7H4.3V6.5C4.3,5.3,5.3,4.3,6.5,4.3z M65.2,92.2v3.4H34.8v-3.4  l11.8-11.8h6.9L65.2,92.2z M93.5,76.1h-87c-1.2,0-2.2-1-2.2-2.2v-4.3h91.3v4.3C95.7,75.1,94.7,76.1,93.5,76.1z"
    />
    <path
      fill={color}
      d="M10.9,60.9h78.3c1.2,0,2.2-1,2.2-2.2V10.9c0-1.2-1-2.2-2.2-2.2H10.9c-1.2,0-2.2,1-2.2,2.2v47.8  C8.7,59.9,9.7,60.9,10.9,60.9z M13,13H87v43.5H13V13z"
    />
    <circle fill="#FF19FF" cx="27" cy="27" r="7" />
    <path
      fill="#00CCFF"
      d="M81,17H43.5c-1.2,0-2.2,1-2.2,2.2V51c0,1.2,1,2.2,2.2,2.2H81c1.2,0,2.2-1,2.2-2.2V19.2  C83.1,18,82.2,17,81,17z M78.8,48.9H45.7V21.4h33.1V48.9z"
    />
    <path
      fill="#0DE22B"
      d="M33.6,38.9h-7.4c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2h7.4c1.2,0,2.2-1,2.2-2.2S34.8,38.9,33.6,38.9z"
    />
    <path
      fill="#0DE22B"
      d="M20.2,38.9L20.2,38.9c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S21.4,38.9,20.2,38.9z"
    />
  </svg>
);
